import Vue from "vue";

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "supervisorGridIsOpen", false);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    },
    setSupervisorGridOpen(state) {
        state.supervisorGridIsOpen = true;
        state.gridIsOpen = false;
    },
    setSupervisorGridClose(state) {
        state.supervisorGridIsOpen = false;
        state.gridIsOpen = true;
    }
}
